import { getApi } from '../../utils/api'

export function getWidgetListConfiguration({ options, page }) {
  return getApi({
    endpoint: `idwell-api/api/v3/widget/widgets/configurations/${page}/`,
    options,
  })
}
